/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TaggedUntaggedResourcesByProductCategoryRequest extends models.CommonCostRequest {
    getFixupPrototypeFunction() { return TaggedUntaggedResourcesByProductCategoryRequest.fixupPrototype; }

    static newInstance(model: Partial<TaggedUntaggedResourcesByProductCategoryRequest>): TaggedUntaggedResourcesByProductCategoryRequest {
        let obj = Object.assign(new TaggedUntaggedResourcesByProductCategoryRequest(), model);
        TaggedUntaggedResourcesByProductCategoryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TaggedUntaggedResourcesByProductCategoryRequest>): TaggedUntaggedResourcesByProductCategoryRequest {
        if (!model) return null;
        return TaggedUntaggedResourcesByProductCategoryRequest.newInstance(<TaggedUntaggedResourcesByProductCategoryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TaggedUntaggedResourcesByProductCategoryRequest) {
        if (!obj) return;

        models.TaggedUntaggedResourcesByProductCategoryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TaggedUntaggedResourcesByProductCategoryRequest): boolean {
        if (models.CommonCostRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TaggedUntaggedResourcesByProductCategoryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
